<!--  -->
<template>
  <div class="project_index_main month_report_main">
    <!-- 面包屑 -->
    <div class="project_breadcrumb_box">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/orghome/project_performance' }">
          项目列表
        </el-breadcrumb-item>
        <el-breadcrumb-item>绩效管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!-- 项目信息 -->
    <div class="project_header_box" style="margin-bottom:15px">
      <el-button type="text" icon="el-icon-arrow-left" @click="$router.back()">返回项目列表</el-button>
    </div>
    <div class="project_detail_box">
      <div class="project_name_box">
        {{ projectInfo.project_name || "加载中..." }}
      </div>
      <div class="project_info_box">
        <p>承接单位：{{ projectInfo.organ_name || "" }}</p>
        <p>
          项目周期：{{ projectInfo.approve_time_str || "" }} ~
          {{ projectInfo.end_time_str || "" }}
        </p>
      </div>
    </div>

    <!-- 项目合同 -->
    <div class="month_report_content_box" style="margin-bottom: 20px">
      <div class="month_report_search_box">
        <h2>项目合同（盖章扫描件）</h2>
      </div>

      <div style="margin-top: 20px">
        <!-- 已有合同文件展示 -->
        <div
          v-if="
            projectInfo.project_contract &&
            projectInfo.project_contract.length > 0
          "
        >
          <div
            v-for="(file, idx) in projectInfo.project_contract"
            :key="idx"
            style="margin-bottom: 10px"
          >
            <a :href="file.href" :download="file.name" target="_blank" style="color: #3381c3; margin-right: 10px">
              <i class="el-icon-document"></i> {{ file.name || '合同文件' + (idx + 1) }}
            </a>
            <el-button type="primary" size="mini" icon="el-icon-download" @click="downloadFile(file)">下载</el-button>
          </div>
        </div>

        <!-- 上传区域 -->
        <el-upload
          class="upload-demo"
          drag
          :action="uploadUrl"
          :on-success="handleContractUploadSuccess"
          :on-error="handleUploadError"
          :before-upload="beforeContractUpload"
          accept=".pdf"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">点击或拖拽文件至此处上传</div>
          <div class="el-upload__tip" slot="tip">
            支持PDF文件，单文件不超过50MB
          </div>
        </el-upload>
      </div>
    </div>

    <!-- 绩效指标（按分类） -->
    <div
      class="month_report_content_box"
      v-for="item in classList"
      :key="item.id"
      style="margin-bottom: 20px"
    >
      <div
        class="month_report_search_box"
        style="display: flex; align-items: center"
      >
        <h2>{{ item.name }}指标</h2>
        <!-- 「其他」分类支持自行添加指标 -->
        <el-button
          v-if="item.name === '其他'"
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="openAddRuleDialog(item)"
          style="margin-left: 20px"
        >
          添加指标
        </el-button>
      </div>
      <div class="month_report_table_box">
        <el-table :data="item.rules" v-if="item.rules && item.rules.length > 0">
          <el-table-column label="序号" width="80">
            <template slot-scope="scope">
              {{ scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column label="指标名称">
            <template slot-scope="scope">
              {{ scope.row.name }}
            </template>
          </el-table-column>
          <el-table-column label="计量规则" width="80">
            <template slot-scope="scope">
              {{ scope.row.rule || "≥" }}
            </template>
          </el-table-column>
          <el-table-column label="单位" width="80">
            <template slot-scope="scope">
              {{ scope.row.unit || "" }}
            </template>
          </el-table-column>
          <el-table-column label="目标值" width="100">
            <template slot-scope="scope">
              {{ scope.row.number || 0 }}
            </template>
          </el-table-column>
          <el-table-column label="累计完成" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.is_active == 0" style="color:#ccc">-</span>
              <span v-else>{{ scope.row.completed || 0 }}</span>
            </template>
          </el-table-column>
          <el-table-column label="完成进度" width="180">
            <template slot-scope="scope">
              <span v-if="scope.row.is_active == 0" style="color:#ccc">不按标准</span>
              <el-progress v-else
                :percentage="Math.min(parseFloat(scope.row.percent) || 0, 100)"
                :color="(parseFloat(scope.row.percent) || 0) >= 100 ? '#27ae60' : '#3381c3'"
              ></el-progress>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="180">
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="small"
                @click="openFillDialog(scope.row)"
              >
                填报
              </el-button>
              <el-button
                type="primary"
                size="small"
                plain
                @click="openHistoryDialog(scope.row)"
              >
                历史记录
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 空状态下提示可自行添加 -->
        <div
          v-else
          style="
            text-align: center;
            padding: 30px;
            color: #999;
            font-size: 14px;
          "
        >
          <span v-if="item.name === '其他'"
            >暂无指标，点击「添加指标」自行添加</span
          >
          <span v-else>暂无指标</span>
        </div>
      </div>
    </div>

    <!-- 填报弹窗 -->
    <el-dialog
      :title="'指标填报 — ' + (currentRule.name || '')"
      :visible.sync="detailShow"
      width="650px"
    >
      <div>
        <el-form v-model="ruleForm" label-position="top">
          <el-form-item label="本次新增完成值">
            <el-input
              v-model="ruleForm.value"
              placeholder="请输入本次新增完成值"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="佐证材料上传">
            <el-upload
              class="upload-demo"
              drag
              :action="uploadUrl"
              :on-success="handleFileUploadSuccess"
              :on-error="handleUploadError"
              :before-upload="beforeUpload"
              :file-list="ruleForm.files"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">点击或拖拽文件至此处上传</div>
              <div class="el-upload__tip" slot="tip">
                支持word、pdf、ppt、excel及压缩包，单文件不超过50MB
              </div>
            </el-upload>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="detailShow = false" plain type="primary">
          取 消
        </el-button>
        <el-button type="warning" @click="handleSaveDraftRecord">
          保存草稿
        </el-button>
        <el-button type="primary" @click="handleSubmitRecord"> 提交 </el-button>
      </div>
    </el-dialog>

    <!-- 历史记录弹窗 -->
    <el-dialog
      :title="'填报历史 — ' + (currentRule.name || '')"
      :visible.sync="historyShow"
      width="1000px"
    >
      <!--  -->
      <div class="project_list_item_content">
        <!-- 本月月报 -->
        <div class="project_list_item_info">
          <div class="project_list_item_menu">
            <p>目标值</p>
            <h2 style="color: #3381c3">{{ currentRule.number || 0 }}</h2>
          </div>
          <div class="project_list_item_menu">
            <p>累计完成</p>
            <h2 style="color: #3381c3">{{ currentRule.completed || 0 }}</h2>
          </div>
          <div class="project_list_item_menu">
            <p>完成率</p>
            <h2 class="yellow">{{ currentRule.percent || 0 }}%</h2>
          </div>
          <div class="project_list_item_menu">
            <p>填报次数</p>
            <h2 class="green">{{ historyList.length }}</h2>
          </div>
        </div>
      </div>
      <div style="margin: 20px 0; width: 100%">
        <!--  -->
        <el-table :data="historyList" style="width:100%">
          <el-table-column label="序号" width="60">
            <template slot-scope="scope">{{ scope.$index + 1 }}</template>
          </el-table-column>
          <el-table-column label="新增值" width="100">
            <template slot-scope="scope">+{{ scope.row.value || 0 }} {{ currentRule.unit || '' }}</template>
          </el-table-column>
          <el-table-column label="提交时间" width="150">
            <template slot-scope="scope">{{ scope.row.create_time ? formatTime(scope.row.create_time) : '' }}</template>
          </el-table-column>
          <el-table-column label="审核状态" width="90">
            <template slot-scope="scope">
              <el-tag :type="scope.row.approve_status==2?'success':scope.row.approve_status==3?'danger':'warning'" size="small">
                {{ scope.row.approve_status==2?'已审核':scope.row.approve_status==3?'已驳回':'审核中' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="驳回原因" min-width="130">
            <template slot-scope="scope">
              <span v-if="scope.row.approve_status==3 && scope.row.refund_reason" style="color:#f56c6c;font-size:12px">{{ scope.row.refund_reason }}</span>
              <span v-else style="color:#ccc">-</span>
            </template>
          </el-table-column>
          <el-table-column label="佐证材料" min-width="140">
            <template slot-scope="scope">
              <template v-if="scope.row.files && scope.row.files.length > 0">
                <div v-for="(file, i) in scope.row.files" :key="i">
                  <a :href="file.href" target="_blank" style="color:#3381c3;margin-right:8px">
                    <i class="el-icon-document"></i> {{ file.name || '查看文件' }}
                  </a>
                  <el-button type="text" size="mini" icon="el-icon-download" @click="downloadFile(file)"></el-button>
                </div>
              </template>
              <span v-else style="color:#ccc">无</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="70">
            <template slot-scope="scope">
              <el-button v-if="scope.row.approve_status == 3" type="warning" size="mini" @click="reSubmitRecord(scope.row)">修改</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="historyShow = false" plain type="primary">
          关闭
        </el-button>
      </div>
    </el-dialog>

    <!-- 添加指标弹窗 -->
    <el-dialog
      title="添加指标"
      :visible.sync="addRuleShow"
      width="550px"
    >
      <div>
        <el-form :model="addRuleForm" label-position="top">
          <el-form-item label="指标名称" required>
            <el-input v-model="addRuleForm.name" placeholder="请输入指标名称"></el-input>
          </el-form-item>
          <el-form-item label="计量规则">
            <el-select v-model="addRuleForm.rule" style="width: 100%">
              <el-option label="≥（大于等于）" value="≥"></el-option>
              <el-option label=">（大于）" value=">"></el-option>
              <el-option label="=（等于）" value="="></el-option>
              <el-option label="≤（小于等于）" value="≤"></el-option>
              <el-option label="<（小于）" value="<"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="单位">
            <el-input v-model="addRuleForm.unit" placeholder="如：人次、次、人、篇、个"></el-input>
          </el-form-item>
          <el-form-item label="目标值" required>
            <el-input v-model.number="addRuleForm.number" placeholder="请输入目标值" type="number"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addRuleShow = false" plain type="primary">取 消</el-button>
        <el-button type="primary" @click="handleSaveRule">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getModuleProjectDetail } from "@/api/module";
import { getRuleList, saveRule, saveProjectContract, saveRuleRecord, getRuleRecordList } from "@/api/module";
import { fileUpUrl } from "@/config";

export default {
  name: "",

  data() {
    return {
      // 上传地址
      uploadUrl: fileUpUrl,
      // 项目ID（从路由获取）
      project_id: 0,
      // 项目详情
      projectInfo: {},
      // 分类指标列表
      classList: [],
      // 整体完成率
      overallPercent: 0,
      // 当前操作的指标
      currentRule: {},
      // 历史记录
      historyList: [],
      // 历史记录弹窗
      historyShow: false,
      // 指标填写弹窗
      detailShow: false,
      // 指标填写表单
      ruleForm: {
        rule_id: 0,
        value: 0,
        files: [],
      },
      // 添加指标弹窗
      addRuleShow: false,
      // 添加指标表单
      addRuleForm: {
        class_id: 0,
        name: "",
        rule: "≥",
        unit: "",
        number: 0,
      },
    };
  },

  created() {
    this.$emit("setActive", { active: 8 });

    // 从路由获取项目ID
    this.project_id = this.$route.query.projectId || 0;

    if (this.project_id) {
      this.getProjectDetail();
      this.fetchRuleList();
    }
  },

  methods: {
    /**
     * 获取项目详情
     */
    async getProjectDetail() {
      const res = await getModuleProjectDetail(this.project_id);
      if (res && res.code === 200) {
        this.projectInfo = res.data || {};
      }
    },

    /**
     * 获取绩效指标列表
     */
    async fetchRuleList() {
      const res = await getRuleList(this.project_id);
      if (res && res.code === 200) {
        this.classList = res.data.class_list || [];
        this.overallPercent = res.data.overall_percent || 0;
      }
    },

    /**
     * 打开填报弹窗
     * @param {Object} rule 当前指标
     */
    openFillDialog(rule) {
      this.currentRule = rule;
      // 有草稿时回填数据；无草稿时清空
      if (rule.has_draft) {
        // 将草稿文件转为 el-upload 需要的格式（name + url）
        const draftFiles = (rule.draft_files || []).map(f => ({
          name: f.name || '佐证材料',
          url: f.href || '',
        }));
        this.ruleForm = {
          rule_id: rule.id,
          id: rule.draft_id || 0,
          value: rule.draft_value || 0,
          files: draftFiles,
        };
      } else {
        this.ruleForm = {
          rule_id: rule.id,
          id: 0,
          value: 0,
          files: [],
        };
      }
      this.detailShow = true;
    },

    /**
     * 打开历史记录弹窗
     * @param {Object} rule 当前指标
     */
    /**
     * 打开历史记录弹窗
     * @param {Object} rule 当前指标
     */
    async openHistoryDialog(rule) {
      this.currentRule = rule;
      this.historyList = [];
      this.historyShow = true;

      // 获取历史填报记录
      const res = await getRuleRecordList(rule.id);
      if (res && res.code === 200) {
        this.historyList = res.data || [];
      }
    },

    /**
     * 保存草稿
     */
    async handleSaveDraftRecord() {
      if (!this.ruleForm.value || this.ruleForm.value <= 0) {
        this.$message.warning('请输入本次完成值');
        return;
      }

      const res = await saveRuleRecord({
        id: this.ruleForm.id || 0,
        rule_id: this.currentRule.id,
        project_id: this.project_id,
        value: this.ruleForm.value,
        files: JSON.stringify(this.ruleForm.files),
        is_save: 1,
      });

      if (res && res.code === 200) {
        this.$message.success('草稿保存成功');
        this.detailShow = false;
        this.fetchRuleList();
      } else {
        this.$message.error((res && res.message) || '保存失败');
      }
    },

    /**
     * 提交填报
     */
    async handleSubmitRecord() {
      if (!this.ruleForm.value || this.ruleForm.value <= 0) {
        this.$message.warning('请输入本次完成值');
        return;
      }

      this.$confirm('确认提交本项资料吗？', '提示', {
        confirmButtonText: '确认提交',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const res = await saveRuleRecord({
          id: this.ruleForm.id || 0,
          rule_id: this.currentRule.id,
          project_id: this.project_id,
          value: this.ruleForm.value,
          files: JSON.stringify(this.ruleForm.files),
          is_save: 0,
        });

        if (res && res.code === 200) {
          this.$message.success('提交成功');
          this.detailShow = false;
          this.fetchRuleList();
        } else {
          this.$message.error((res && res.message) || '提交失败');
        }
      }).catch(() => {});
    },

    /**
     * 驳回后重新提交（保留原值和文件）
     * @param {Object} record 被驳回的记录
     */
    reSubmitRecord(record) {
      this.historyShow = false;
      const recordFiles = (record.files || []).map(f => ({ name: f.name || '佐证材料', url: f.href || '' }));
      this.ruleForm = {
        rule_id: this.currentRule.id,
        id: record.id,
        value: record.value || 0,
        files: recordFiles,
      };
      this.detailShow = true;
    },

    /**
     * 打开添加指标弹窗
     * @param {Object} classItem 分类数据
     */
    openAddRuleDialog(classItem) {
      this.addRuleForm = {
        class_id: classItem.id,
        name: "",
        rule: "≥",
        unit: "",
        number: 0,
      };
      this.addRuleShow = true;
    },

    /**
     * 保存新指标
     */
    async handleSaveRule() {
      if (!this.addRuleForm.name) {
        this.$message.warning("请输入指标名称");
        return;
      }
      if (!this.addRuleForm.number || this.addRuleForm.number <= 0) {
        this.$message.warning("请输入有效的目标值");
        return;
      }

      const res = await saveRule({
        project_id: this.project_id,
        class_id: this.addRuleForm.class_id,
        name: this.addRuleForm.name,
        rule: this.addRuleForm.rule,
        unit: this.addRuleForm.unit,
        number: this.addRuleForm.number,
      });

      if (res && res.code === 200) {
        this.$message.success("指标添加成功");
        this.addRuleShow = false;
        this.fetchRuleList();
      } else {
        this.$message.error((res && res.message) || "添加失败");
      }
    },

    /**
     * 下载文件
     * @param {Object} file {name, href}
     */
    downloadFile(file) {
      const url = uploadUrl.replace('/upload', '/download') + '?url=' + encodeURIComponent(file.href) + '&name=' + encodeURIComponent(file.name || '文件');
      window.open(url, '_blank');
    },

    /**
     * 通用上传前校验
     * @param {Object} file
     */
    beforeUpload(file) {
      const maxSize = 50 * 1024 * 1024; // 50MB
      if (file.size > maxSize) {
        this.$message.error('文件大小不能超过50MB');
        return false;
      }
      return true;
    },

    /**
     * 项目合同上传前校验（仅PDF）
     * @param {Object} file
     */
    beforeContractUpload(file) {
      const maxSize = 50 * 1024 * 1024; // 50MB
      if (file.size > maxSize) {
        this.$message.error('文件大小不能超过50MB');
        return false;
      }
      const isPdf = file.type === 'application/pdf' || file.name.toLowerCase().endsWith('.pdf');
      if (!isPdf) {
        this.$message.error('项目合同仅支持上传PDF文件');
        return false;
      }
      return true;
    },

    /**
     * 项目合同上传成功回调
     * @param {Object} response 上传响应
     */
    async handleContractUploadSuccess(response) {
      if (response && response.code === 200) {
        const fileData = response.data || {};
        const newFile = {
          name: fileData.file_name || '合同文件',
          href: fileData.file_path || '',
        };

        // 追加到合同文件列表并保存
        const contractList = this.projectInfo.project_contract || [];
        contractList.push(newFile);

        const res = await saveProjectContract(this.project_id, contractList);
        if (res && res.code === 200) {
          this.$message.success('合同上传成功');
          this.getProjectDetail();
        }
      } else {
        this.$message.error((response && response.message) || '上传失败');
      }
    },

    /**
     * 佐证材料上传成功回调
     * @param {Object} response 上传响应
     */
    handleFileUploadSuccess(response) {
      if (response && response.code === 200) {
        const fileData = response.data || {};
        this.ruleForm.files.push({
          name: fileData.file_name || '佐证材料',
          url: fileData.file_path || '',
          href: fileData.file_path || '',
        });
      } else {
        this.$message.error((response && response.message) || '上传失败');
      }
    },

    /**
     * 上传失败回调
     */
    handleUploadError() {
      this.$message.error('文件上传失败，请重试');
    },

    /**
     * 格式化时间戳
     * @param {Number} timestamp
     */
    formatTime(timestamp) {
      if (!timestamp) return "";
      const d = new Date(timestamp * 1000);
      const pad = (n) => String(n).padStart(2, "0");
      return (
        d.getFullYear() +
        "-" +
        pad(d.getMonth() + 1) +
        "-" +
        pad(d.getDate()) +
        " " +
        pad(d.getHours()) +
        ":" +
        pad(d.getMinutes())
      );
    },
  },
};
</script>

<style scoped lang="scss">
@import url("index.scss");
@import url("performance.scss");
</style>
